import * as React from 'react'
import styled from 'styled-components'
import Svg from './Svg'

function BaseComponent(props: any) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm2 2.45a2.5 2.5 0 10-1 0v7.55a.5.5 0 001 0V5.95z"
        fill="currentColor"
      />
    </Svg>
  )
}

const SvgSewingPin = styled(BaseComponent)`
  outline: none;
`
export default SvgSewingPin
